import { render, staticRenderFns } from "./EditIdtypeDialog.vue?vue&type=template&id=0d515b1e&scoped=true&"
import script from "./EditIdtypeDialog.vue?vue&type=script&lang=js&"
export * from "./EditIdtypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditIdtypeDialog.vue?vue&type=style&index=0&id=0d515b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d515b1e",
  null
  
)

export default component.exports